
export const baseTruncateString = (string: string, wordCount = 30, withEllipsis = true) => {
  if (!string) { return null }
  if (typeof string !== 'string') { return null }

  const wordsInString = string?.replace(/(<([^>]+)>)/gi, ' ')?.replace(/\s+/g, ' ')?.trim()?.split(/\s+/)

  const ellipsis = wordsInString?.length > wordCount && withEllipsis === true ? ' …' : ''

  const truncatedString = wordsInString?.slice(0, wordCount)?.join(' ')

  return `${truncatedString}${ellipsis}`
}
